<template>
  <div
    class="card row soft q-py-md no-shrink justify-around text-center"
    style="margin-top: 0"
  >
    <a
      v-for="(choice, index) in choices"
      :key="index"
      class="q-pa-sm col-4"
      :class="anchorClass(choice)"
      href="#"
      @click.prevent="setRange(choice)"
    >
      {{ choice.toString() }}
    </a>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";

import DateRange from "shared/helpers/DateRange";
import { useUserStore } from "shared/stores/user";

export default {
  name: "RangeSelector",
  props: {
    range: {
      type: DateRange,
      required: true,
    },
  },
  emits: ["update:range"],
  setup() {
    const userStore = useUserStore();
    const { organisation } = storeToRefs(userStore);

    return { organisation };
  },
  data() {
    return {
      choices: [
        DateRange.today(),
        DateRange.yesterday(),
        DateRange.lastThreeDays(),
        DateRange.lastSevenDays(),
        DateRange.lastThirtyDays(),
        DateRange.lastNinetyDays(),
        DateRange.currentMonth(),
        DateRange.lastMonth(),
      ],
    };
  },
  computed: {
    canShowYear() {
      return this.organisation.max_date_range === 12;
    },
  },
  mounted() {
    if (this.canShowYear) {
      this.choices.push(DateRange.lastYear());
    }
  },
  methods: {
    anchorClass(choice) {
      return {
        highlight: this.range && this.range.toString() === choice.toString(),
      };
    },
    setRange(range) {
      this.$emit("update:range", range);
    },
  },
};
</script>
